import * as React from "react";
import {cx} from "emotion";

import "./order-editor.scss";

import {isKit,
        isPickPack,
        isUyoMPB}          from "@Common/logic/template-options/template-options-pickpack-data-logic";
import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {Static2}           from "@Common/react/static-2";
import {PaywallModal}      from "@Common/ui-components/paywall-modal/paywall-modal"

import {IconTooltip}       from "@Xpresso/common/tool-tip";

import {AGENT_LEVEL}           from "../../../../common/logic/user-level";
import {ListingType}           from "../modules/listing-type/ui/listing-type";
import {PickupAddress}         from "../modules/pickup-address/pickup-address";
import {PickPack}              from "../modules/pick-pack/ui/pick-pack";
import {YardSign}              from "../modules/yard-sign/ui/yard-sign";
import {getMaxValueForIsProof} from "../product-options-step";

export const OrderEditor = (
    {
        templateOptions, templateBack, customizeFlow, customizeAction, templateBackId,
        oia, itemOptions, isFromApproval, prepareSave, item
    }
) => cs(
    consumeContext('apis'),
    consumeContext('company'),
    consumeContext("catSubStyle"),
    consumeContext("routerHistory"),
    ["buttonLabel", ({company},next) => next(
        company?.prefs?.xpressoKitOptionsActive && isKit(templateOptions) ? (
            "KIT OPTIONS"
        ) : (!customizeFlow.legacy || !customizeFlow.legacy.xpressoCheckout) ? (
            "CUSTOMIZE"
        ) : customizeFlow.needsDistributionOptions ? (
            "DISTRIBUTION OPTIONS"
        ) : (
            "Proceed to Checkout"
        )
    )],
    ["subId", ({}, next) => next(templateOptions?.subCategories.frontTemplate.id)],
    ["adminCustomizeButtonAvailable", (_, next) => next(
        !customizeFlow.legacy || !customizeFlow.legacy.xpressoCheckout || isPickPack(templateOptions) || isUyoMPB(templateOptions) || !getMaxValueForIsProof(itemOptions) ? (
            false
        ) : (
            true
        )
    )],
    ["paywallModal", ({}, next) => PaywallModal({next})],
    ["eventListener", ({}, next) => Static2({next})],
    consumeContext("userLevels"),
    ({buttonLabel, userLevels, adminCustomizeButtonAvailable, paywallModal, routerHistory}) => (
        <div className="order-editor-3f6">
            {checkForPaywall({templateOptions}) &&
                <div className="subscriber-only">
                    This template is only available to <span className="primary">XD+ Yearly</span> subscribers.
                    <br></br><a className="link" onClick={() => routerHistory.push("/manage-subscriptions")}>Click Here</a> to learn more!
                </div>
            }

            {templateOptions && templateBack && <IconTooltip/>}

            {itemOptions.ui.orderInfo({
                className: "section",
                templateOptions,
                oia: !!oia,
            })}

            {!oia && isUyoMPB(templateOptions) && itemOptions.ui.uyo({prepareSave})}

            {itemOptions.ui.deliveryMethod}

            {itemOptions.ui.lineItems}

            {itemOptions.ui.mailingClass}

            {itemOptions.ui.pickupAddress?.({
                className: "section",
            })}

            {itemOptions.ui.quantity?.({
                className: "section",
            })}

            {itemOptions.ui.paperType?.({
                className: "section",
                templateBack,
                templateBackId,
                oia,
                templateOptions,
            })}

            {itemOptions.ui.pdfDownload?.({
                className: "section",
            })}

            {itemOptions.ui.pickPack && PickPack({
                ...itemOptions.ui.pickPack,
                className: "section",
            })}

            {itemOptions.ui.yardSign && YardSign({
                ...itemOptions.ui.yardSign,
                className: "section",
            })}

            {itemOptions.ui.downloadDelivery?.({
                className: "section",
            })}


            {itemOptions.ui.listingType && ListingType({
                ...itemOptions.ui.listingType,
                className: "section",
                templateOptions,
            })}

            {itemOptions.ui.variationSelection}

            {(() => {
                const btnClass = (
                    !itemOptions.itemEditor.valid ||
                    oia && (!oia.proofs && !item?.metaData?.pdfValidation?.thumbnails)
                ) ? "disabled" : "";

                const wrapSubmit = async (submit) => {
                    if(checkForPaywall({templateOptions})) {
                            paywallModal.show();
                            return;
                    }
                    if (!itemOptions.itemEditor.valid) {
                        itemOptions.itemEditor.errorsHandling?.highlightErrors?.();
                        return;
                    }
                    if (!(oia && (!oia.proofs && !item?.metaData?.pdfValidation?.thumbnails))) {
                        checkForPaywall({templateOptions}) ? (
                            paywallModal.show()
                        ) : (
                            await submit()
                        )
                    }
                };

                return <>
                    <div className="controls">

                        {adminCustomizeButtonAvailable && userLevels.userLevel < AGENT_LEVEL && (
                            <button
                                className={cx("customize-btn1", btnClass)}
                                xd-qa-type="button"
                                xd-qa-name="CUSTOMIZE"
                                onClick={() => wrapSubmit(() => customizeAction({
                                    forceCustomize: true,
                                    approval: false,
                                    checkForPaywall: () => checkForPaywall({templateOptions}),
                                }))}
                            >CUSTOMIZE</button>
                        )}

                        <button
                            className={cx("customize-btn", btnClass)}
                            xd-qa-type="button"
                            xd-qa-name={buttonLabel}
                            onClick={() => wrapSubmit(() => customizeAction({
                                forceCustomize: false,
                                approval: false,
                                checkForPaywall: () => checkForPaywall({templateOptions}),
                            }))}
                        >
                            {buttonLabel}
                        </button>

                        {isFromApproval && buttonLabel !== "Proceed to Checkout" && (
                            <button
                                className={cx("approval-btn", btnClass)}
                                xd-qa-type="button"
                                xd-qa-name="Approval"
                                onClick={() => wrapSubmit(() => customizeAction({
                                    forceCustomize: false,
                                    approval: true,
                                    checkForPaywall: () => checkForPaywall({templateOptions}),
                                }))}
                            >SAVE &amp; PROCEED TO CHECKOUT</button>
                        )}

                    </div>
                    <div className="controls">

                        {adminCustomizeButtonAvailable && userLevels.internalUser && userLevels.userLevel === AGENT_LEVEL && (
                            <button
                                className={cx("customize-link", btnClass)}
                                xd-qa-type="button"
                                xd-qa-name="INTERNAL USER CUSTOMIZE"
                                onClick={async () => {
                                    if (!itemOptions.itemEditor.valid) {
                                        itemOptions.itemEditor.errorsHandling?.highlightErrors?.();
                                        return;
                                    }
                                    await customizeAction({
                                        forceCustomize: true,
                                        approval: false,
                                        checkForPaywall: () => checkForPaywall({templateOptions}),
                                    });
                                }}
                            >INTERNAL USER CUSTOMIZE</button>
                        )}
                    </div>
                </>;
            })()}

        </div>
    ),
);

const checkForPaywall = ({templateOptions}) => {
    return templateOptions?.subscription?.showPaywall
}
